module.exports = __webpack_public_path__ + "static/media/ic_audio_on_small_transparent.8c125e73.svg";